/**
 * <tm-copy-code data-code="{{ discount_code }}">
 *   <button type="button" aria-label="Copy discount code {{ discount_code }}">Copy</button>
 * </tm-copy-code>
 *
 * Copies the code in data-code to the clipboard on button click, flips the
 * button label to "Copied" for ~1.8s, then restores it. No page reload, no
 * navigation. If the Clipboard API is unavailable, the button simply does
 * nothing when clicked -- the cart keeps working either way.
 */
if (!customElements.get('tm-copy-code')) {
  class TmCopyCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.code = this.dataset.code || '';

      if (!this.button || !this.code || !navigator.clipboard?.writeText) return;

      this.defaultLabel = this.button.textContent.trim();
      this.defaultAriaLabel = this.button.getAttribute('aria-label') || '';
      this.copiedLabel = this.dataset.copiedLabel || 'Copied ✓';

      this.button.addEventListener('click', () => this.copy());
    }

    copy() {
      navigator.clipboard
        .writeText(this.code)
        .then(() => this.showCopied())
        .catch(() => {});
    }

    showCopied() {
      clearTimeout(this.resetTimer);
      this.button.textContent = this.copiedLabel;
      this.button.setAttribute('aria-label', `${this.copiedLabel}: ${this.code}`);
      this.resetTimer = setTimeout(() => {
        this.button.textContent = this.defaultLabel;
        this.button.setAttribute('aria-label', this.defaultAriaLabel);
      }, 1800);
    }
  }

  customElements.define('tm-copy-code', TmCopyCode);
}
